import React, { Component } from 'react';
import { connect } from 'react-redux';
import BotPanelBanner from './BotPanelBanner';
import FreeTrialBanner from './FreeTrialBanner';
import PersonalSaleBanner from './PersonalSaleBanner';
import ActiveSaleBanner from './ActiveSaleBanner';
import PremiumUpgradeBanner from './PremiumUpgradeBanner';
import VoteBanner from './VoteBanner';
import PremiumTokenBanner from './PremiumTokenBanner';
import PriorityHostingBanner from './PriorityHostingBanner';
import PriorityTokensBanner from './PriorityTokensBanner';
import AlphaModeBanner from './AlphaModeBanner';
import moment from 'moment';

export class BannerRender extends Component {
    canShowVoteBanner = () => {
        const { user } = this.props;
        if (!user || !user.created_at) return false;

        // Check if account is older than 3 months
        const accountAge = moment().diff(moment(user.created_at), 'months');

        return accountAge > 1;
    };

    renderBanner() {
        // For development, show the PremiumTokenBanner
        // In production, you would want to check: !this.props.premium && this.props.user.tokens >= 1

        // If dashboard is in alpha mode, show the alpha mode banner
        if (process.env.REACT_APP_ALPHA_MODE === 'true') {
            return <AlphaModeBanner />;
        }

        // If user has priority hosting, show the priority hosting banner
        if (this.props.user?.prio_hosting === true) {
            return <PriorityHostingBanner />;
        }


        // If there's an active sale, show the sale banner
        if (this.props.active_sale?.code) {
            return (
                <div>
                    <ActiveSaleBanner />
                </div>
            );
        } else if (!this.props.premium && this.props.user.tokens >= 1) {
            return (
                <div>
                    <PremiumTokenBanner />
                </div>
            );
        }

        else if (!this.props.premium && !this.props.user.server_claimed) {
            return (
                <div>
                    <FreeTrialBanner />
                </div>
            );
        } else if (this.props.premium) {
            return (
                <div>
                    <PriorityTokensBanner />
                </div>
            );
        }
        // If there is an active sale, show the sale banner

        // Else if free trial claimed and they currently have a free trial premium, show them the personal sale banner
        else if (!this.props.premium && this.props.user.personal_sale) {
            return (
                <div>
                    <PersonalSaleBanner />
                </div>
            );
        }
        // If user can see vote banner, show it
        else if (this.canShowVoteBanner() && !this.props.premium) {
            return <VoteBanner />;
        }
        // If user doesn't have premium, show the premium upgrade banner
        else if (!this.props.premium) {
            return (
                <div>
                    <PremiumUpgradeBanner />
                </div>
            );
        }

        // Else show the normal banner
        else {
            return <BotPanelBanner />;
        }
    }

    render() {
        return (
            <>
                {this.renderBanner()}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    premium: state.data.premium,
    user: state.data.user,
    active_sale: state.data.active_sale,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BannerRender);